<template>
<div>
    <card class="mb-3" size="small" state="bad" scroll-on-show="true" v-show="error_message.length">
        <template slot="body">
            <strong>Error!</strong> {{ error_message }}
        </template>
    </card>

    <card>
        <template slot="body">
            Logging you out now...
        </template>
    </card>
</div>
</template>

<script>
import store from "@/store"

export default {
    name: "logout-page",

    data () {
        return {
            error_message: ""
        }
    },

    async mounted () {
        await store.dispatch("logout")

        window.location.href = "/login"
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/LogoutPage.vue